"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalFonts = exports.FrutigerFont = exports.AvantGardeFont = exports.IconFont = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
exports.IconFont = (0, styled_components_1.createGlobalStyle) `
${({ dirName }) => {
    return (0, styled_components_1.css) `
    @font-face {
      font-family: "iconfont";
      src: url("${dirName}/iconfont/iconfont.eot") format("embedded-opentype"),
        url("${dirName}/iconfont/iconfont.woff2") format("woff2"),
        url("${dirName}/iconfont/iconfont.woff") format("woff");
    }
  `;
}}
`;
exports.AvantGardeFont = (0, styled_components_1.createGlobalStyle) `
${({ dirName }) => {
    return (0, styled_components_1.css) `
    @font-face {
      font-family: "AvantGarde";
      src: url("${dirName}/avant-garde/ITCAvantGardeStd-Bk.eot")
          format("embedded-opentype"),
        url("${dirName}/fonts/avant-garde/ITCAvantGardeStd-Bk.woff2")
          format("woff2"),
        url("${dirName}/avant-garde/ITCAvantGardeStd-Bk.woff") format("woff");
      font-weight: 400;
      font-style: normal;
      font-display: swap;
    }
  `;
}}
`;
exports.FrutigerFont = (0, styled_components_1.createGlobalStyle) `
${({ dirName }) => {
    return (0, styled_components_1.css) `
    @font-face {
      font-family: "Frutiger";
      src: url("${dirName}/frutiger/Frutiger.eot") format("embedded-opentype"),
        url("${dirName}/frutiger/Frutiger.woff2") format("woff2"),
        url("${dirName}/frutiger/Frutiger.woff") format("woff");
      font-weight: 400;
      font-style: normal;
      font-display: swap;
    }
  `;
}}
`;
function GlobalFonts(_a) {
    var { dirName = "/fonts" } = _a, props = __rest(_a, ["dirName"]);
    props = Object.assign({ dirName }, props);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.IconFont, Object.assign({}, props)),
        react_1.default.createElement(exports.AvantGardeFont, Object.assign({}, props)),
        react_1.default.createElement(exports.FrutigerFont, Object.assign({}, props))));
}
exports.GlobalFonts = GlobalFonts;
//# sourceMappingURL=fonts.js.map